import {
  _getTextHeight as getTextHeight,
  type TruncationMode,
  _getTextWidth as getTextWidth,
} from '@dynatrace/strato-components/typography';

import { ITEM_FONT_STYLES, LABEL_HOVERED_PADDING } from '../constants.js';
import { getVerticalLabelPosition } from './get-vertical-label-position.js';
import { calculateOptimalEllipsis } from './labels-collision.js';
import {
  HorizontalCoords,
  LabelAlignment,
  RangeLabel,
} from '../types/range-legend.internal.js';

/**
 * Check if for the given label position the text will fit in the bounds of the container.
 * In the case where the label does not fit applies the ellipsis to it.
 */
export const handleCollisionInVerticalLayout = (
  labelText: string,
  segment: HorizontalCoords,
  alignment: LabelAlignment,
  truncationMode: TruncationMode,
  bounds: number[],
): RangeLabel => {
  const labelWidth = getTextWidth(labelText, ITEM_FONT_STYLES);
  const labelHeight = getTextHeight(labelText, ITEM_FONT_STYLES);
  const { x, y } = getVerticalLabelPosition(
    labelHeight,
    segment.start,
    segment.end,
    alignment,
  );

  const isTruncationNeeded = x + LABEL_HOVERED_PADDING + labelWidth > bounds[1];

  if (isTruncationNeeded) {
    const { text } = calculateOptimalEllipsis(
      labelText,
      x,
      x + labelWidth,
      truncationMode,
      bounds[0],
      bounds[1],
    );

    return { text, x, y };
  }

  return { text: labelText, x, y };
};
